import { motion } from "framer-motion";

// Word/line mask reveal
export function MaskReveal({ children, delay = 0, className = "" }) {
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        style={{ display: "inline-block", willChange: "transform" }}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.95, ease: [0.7, 0.02, 0.28, 1], delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

// Fade + rise on scroll into view
export function Rise({ children, delay = 0, y = 40, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

// Static overline / eyebrow label
export function Overline({ children, className = "" }) {
  return (
    <span
      className={`font-ui text-[11px] md:text-xs uppercase tracking-editorial text-[color:var(--ink-light)] ${className}`}
    >
      {children}
    </span>
  );
}
